import { Injectable, computed, signal } from '@angular/core';
import { GqlOperationPathEnum } from '@/common/enums/gql-operation-path.enum';

export type AppError = {
  message: string;
  code?: string;
  path?: GqlOperationPathEnum;
};

@Injectable({ providedIn: 'root' })
export class ErrorService {
  private readonly _global = signal<AppError | null>(null);
  private readonly _byPath = signal<Record<string, AppError | null>>({});

  setGlobal(err: AppError | null) {
    this._global.set(err);
  }

  clearGlobal() {
    this._global.set(null);
  }

  global = computed(() => this._global());

  setForPath(path: GqlOperationPathEnum, err: AppError | null) {
    this._byPath.update((curr) => ({ ...curr, [path]: err }));
  }

  clearForPath(path: GqlOperationPathEnum) {
    this.setForPath(path, null);
  }

  signalForPath(path: GqlOperationPathEnum) {
    return computed(() => this._byPath()[path] ?? null);
  }
}
